import React, { useState } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { ProfileCard } from "../../components/ui-library/ProfileCard/ProfileCard";
import SmartPageHeader from "../../components/smart/PageHeader/PageHeader";
import StudyEntriesDatepicker from "../../components/smart/StudyEntriesDatepicker/StudyEntriesDatepicker";
import StudyEntriesTable from "../../components/smart/LCF401/StudyEntriesTable/StudyEntriesTable";

const Stats = (props) => {
  const {
    route: { study },
    match: {
      params: { participantId },
    },
    userData,
    studyEntriesDatePicker: { formattedDateRange = undefined } = {},
    loginReducer: { studies },
  } = props;

  const { t } = useTranslation();

  const [update, setUpdate] = useState(false);

  return (
    <>
      <SmartPageHeader
        title={studies && studies[0]?.code}
        participantId={participantId}
        shouldFetchParticipant={true}
        studyId={study}
      />

      <StudyEntriesDatepicker
        {...{ study }}
        {...{ participantId }}
        dateRange={formattedDateRange}
        onUpdate={() => setUpdate(false)}
        {...{ update }}
      />

      <div className="mt-5">
        <ProfileCard
          title={t("contentText.dietDiary.entriesTable.title")}
          showIcon={false}
        >
          <StudyEntriesTable
            {...{ study }}
            {...{ participantId }}
            userData={userData}
            dateRange={formattedDateRange}
            onUpdate={() => setUpdate(true)}
          />
        </ProfileCard>
      </div>
    </>
  );
};

export default connect((state) => {
  return {
    studyEntriesDatePicker: state?.studyEntriesDatePickerReducer,
    userData: state?.smartPageHeaderReducer,
    loginReducer: state?.loginReducer,
  };
})(Stats);
